// src/pages/AgentCommandCenter/AgentCommandCenter.js
import React, { useState } from 'react';
import './AgentCommandCenter.css';

const AgentCommandCenter = () => {
    // Toggle for the expanded console modal
    const [showExpandedConsole, setShowExpandedConsole] = useState(false);
    // Toggle for the "Call Outcome" modal
    const [showOutcomeModal, setShowOutcomeModal] = useState(false);

    // Some dummy data for the default console
    const callHistory = [
        {
            contactName: 'John Doe',
            phoneNumber: '(123) 456-7890',
            timeOfCall: '10:15 AM',
            duration: '5 min',
            transcriptLink: '#',
            actionTaken: 'Follow-Up Needed',
        },
        {
            contactName: 'Jane Smith',
            phoneNumber: '(987) 654-3210',
            timeOfCall: '11:00 AM',
            duration: '8 min',
            transcriptLink: '#',
            actionTaken: 'Deal Closed - Won',
        },
    ];

    const transcriptMessages = [
        { sender: 'SLAI Agent', text: 'Can you confirm your legal status?' },
        { sender: 'Emily Johnson', text: 'I am not a U.S. citizen.' },
        { sender: 'SLAI Agent', text: 'Did you use a coyote to cross the border?' },
        { sender: 'Emily Johnson', text: 'Yes I used a Coyote.' },
    ];

    // For the top bar toggles & date
    const [isActive, setIsActive] = useState(true);
    const handleToggle = () => setIsActive((prev) => !prev);

    // Modal open/close for main console
    const openExpandedConsole = () => setShowExpandedConsole(true);
    const closeExpandedConsole = () => setShowExpandedConsole(false);

    // Modal open/close for "Call Outcome"
    const openOutcomeModal = () => setShowOutcomeModal(true);
    const closeOutcomeModal = () => setShowOutcomeModal(false);

    return (
        <div className="agent-command-center-container">
            {/* HEADER */}
            <header className="agent-command-header">
                <h1>Agent Command Center</h1>
                <div className="header-right">
                    <div className="date-select">
                        <label htmlFor="dateFilter">Date:</label>
                        <select id="dateFilter">
                            <option>Today</option>
                            <option>Yesterday</option>
                            <option>Last 7 Days</option>
                        </select>
                    </div>
                    <div className="active-toggle">
                        <span>Inactive</span>
                        <label className="switch">
                            <input
                                type="checkbox"
                                checked={isActive}
                                onChange={handleToggle}
                            />
                            <span className="slider round"></span>
                        </label>
                        <span>Active</span>
                    </div>
                </div>
            </header>

            {/* MAIN CONTENT */}
            <main className="main-content">
                {/* LEFT MAIN SECTION */}
                <section className="left-main-section">
                    {/* KPI Row */}
                    <div className="kpi-row">
                        <div className="kpi-card">
                            <p className="kpi-title">Calls Taken</p>
                            <p className="kpi-value">55</p>
                        </div>
                        <div className="kpi-card">
                            <p className="kpi-title">Deals Won</p>
                            <p className="kpi-value">4</p>
                        </div>
                        <div className="kpi-card">
                            <p className="kpi-title">Closing Rate</p>
                            <p className="kpi-value">7%</p>
                        </div>
                        <div className="kpi-card">
                            <p className="kpi-title">Hours Active</p>
                            <p className="kpi-value">4:21</p>
                        </div>
                    </div>

                    {/* Lead Categorization */}
                    <div className="lead-categorization">
                        <div className="cat-box gray">
                            Disconnected <span>15</span>
                        </div>
                        <div className="cat-box blue">
                            Reschedule <span>8</span>
                        </div>
                        <div className="cat-box yellow">
                            Follow-Up Needed <span>10</span>
                        </div>
                        <div className="cat-box green">
                            Deal Closed - Won <span>12</span>
                        </div>
                        <div className="cat-box red">
                            Deal Closed - Lost <span>5</span>
                        </div>
                        <div className="cat-box orange">
                            Price Objection <span>7</span>
                        </div>
                        <div className="cat-box purple">
                            Needs More Info <span>9</span>
                        </div>
                        <div className="cat-box teal">
                            Unqualified Lead <span>4</span>
                        </div>
                    </div>

                    {/* Call History Table */}
                    <div className="call-history-section">
                        <h2>Call History</h2>
                        <table className="call-history-table">
                            <thead>
                            <tr>
                                <th>Contact Name</th>
                                <th>Phone Number</th>
                                <th>Time of Call</th>
                                <th>Duration</th>
                                <th>Transcript</th>
                                <th>Action Taken</th>
                            </tr>
                            </thead>
                            <tbody>
                            {callHistory.map((call, idx) => (
                                <tr key={idx}>
                                    <td>{call.contactName}</td>
                                    <td>{call.phoneNumber}</td>
                                    <td>{call.timeOfCall}</td>
                                    <td>{call.duration}</td>
                                    <td>
                                        <a href={call.transcriptLink} className="view-transcript">
                                            View Transcript
                                        </a>
                                    </td>
                                    <td>{call.actionTaken}</td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                </section>

                {/* RIGHT PANEL */}
                <aside className="right-panel">
                    <div className="agent-call-console">
                        <h3>Agent Call Console</h3>
                        {/* Client info card */}
                        <div className="client-info-card">
                            <h4>Client Information</h4>
                            <p>
                                <strong>Name:</strong> Emily Johnson
                            </p>
                            <p>
                                <strong>Phone Number:</strong> (655) 123-4567
                            </p>
                            <p>
                                <strong>Email:</strong> emily.johnson@example.com
                            </p>
                            <p>
                                <strong>Campaign:</strong> Immigration Support
                            </p>
                            <p>
                                <strong>Location:</strong> Los Angeles, CA
                            </p>
                        </div>

                        {/* Qualifications */}
                        <div className="qualifications-section">
                            <h4>Qualifications</h4>
                            <div className="qualification-badge">Married to US Citizen</div>
                            <div className="qualification-badge">Has kids over 21</div>
                            <div className="qualification-badge">Used a Coyote</div>
                        </div>

                        {/* Call transcript */}
                        <div className="transcript-section">
                            <h4>Call Transcript</h4>
                            <div className="transcript-messages">
                                {transcriptMessages.map((msg, i) => (
                                    <div
                                        key={i}
                                        className={`msg-row ${
                                            msg.sender === 'SLAI Agent' ? 'agent' : 'client'
                                        }`}
                                    >
                                        <p className="sender">{msg.sender}</p>
                                        <div className="msg-bubble">{msg.text}</div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Microphone & Expand button */}
                        <div className="mic-row">
                            <img src="/icons/mic.png" alt="Mic" />
                            <span>Microphone on.</span>
                        </div>
                        <button className="expand-console-btn" onClick={openExpandedConsole}>
                            Expand Column to see actions
                        </button>
                    </div>
                </aside>
            </main>

            {/* The Expand Modal */}
            {showExpandedConsole && (
                <div className="expanded-modal-overlay">
                    <div className="expanded-modal-content">
                        <div className="expanded-modal-header">
                            <h3>Agent Call Console</h3>
                            <div className="call-status">ACTIVE CALL - 00:05:23</div>
                            <button className="modal-close-btn" onClick={closeExpandedConsole}>
                                &times;
                            </button>
                        </div>

                        <div className="expanded-console-body">
                            {/* Left half */}
                            <div className="expanded-left">
                                <div className="client-info-card">
                                    <h4>Client Information</h4>
                                    <p>
                                        <strong>Name:</strong> Emily Johnson
                                    </p>
                                    <p>
                                        <strong>Phone Number:</strong> (655) 123-4567
                                    </p>
                                    <p>
                                        <strong>Email:</strong> emily.johnson@example.com
                                    </p>
                                    <p>
                                        <strong>Campaign:</strong> Immigration Support
                                    </p>
                                    <p>
                                        <strong>Location:</strong> Los Angeles, CA
                                    </p>
                                </div>

                                <div className="qualifications-section">
                                    <h4>Qualifications</h4>
                                    <div className="qualification-badge">Married to US Citizen</div>
                                    <div className="qualification-badge">Has kids over 21</div>
                                    <div className="qualification-badge">Used a Coyote</div>
                                </div>

                                <div className="transcript-section">
                                    <h4>Call Transcript</h4>
                                    <div className="transcript-messages expanded">
                                        {transcriptMessages.map((msg, i) => (
                                            <div
                                                key={i}
                                                className={`msg-row ${
                                                    msg.sender === 'SLAI Agent' ? 'agent' : 'client'
                                                }`}
                                            >
                                                <p className="sender">{msg.sender}</p>
                                                <div className="msg-bubble">{msg.text}</div>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                <div className="mic-row" style={{ marginTop: '1rem' }}>
                                    <img src="/icons/mic.png" alt="Mic" />
                                    <span>Microphone on.</span>
                                </div>
                            </div>

                            {/* Right half: big notes area. AI Tools commented out. */}
                            <div className="expanded-right">
                                {/* Big notes area (height increased) */}
                                <textarea
                                    className="notes-textarea"
                                    placeholder="Type notes here..."
                                    style={{ height: '300px' }}
                                ></textarea>

                                {/*
                Commenting out the AI Assistance Tools for now:

                <div className="ai-assistance-tools">
                  <h4>AI Assistance Tools</h4>
                  <label>Choose Objection</label>
                  <select value={objection} onChange={(e) => setObjection(e.target.value)}>
                    <option value="Too Expensive...">Too Expensive...</option>
                    <option value="Not Interested...">Not Interested...</option>
                    <option value="Need More Info...">Need More Info...</option>
                  </select>

                  <label>SLAI Response</label>
                  <textarea
                    className="srai-response-textarea"
                    value={aiResponse}
                    onChange={(e) => setAiResponse(e.target.value)}
                  ></textarea>

                  <button className="generate-response-btn" onClick={handleGenerateResponse}>
                    Generate New Response
                  </button>
                </div>

                <div className="post-call-actions">
                  <h4>Post Call Actions</h4>
                  <div className="post-actions-grid">
                    <div className="cat-box gray">Disconnected</div>
                    <div className="cat-box blue">Reschedule</div>
                    <div className="cat-box yellow">Follow-Up Needed</div>
                    <div className="cat-box green">Deal Closed - Won</div>
                    <div className="cat-box red">Deal Closed - Lost</div>
                    <div className="cat-box orange">Price Objection</div>
                    <div className="cat-box purple">Needs More Info</div>
                    <div className="cat-box teal">Unqualified Lead</div>
                  </div>
                </div>
                */}

                            </div>
                        </div>

                        {/* Bottom call actions - new "Call Outcome" button */}
                        <div className="expanded-call-actions">
                            <button className="answer-btn">Answer</button>
                            <button className="decline-btn">Decline</button>
                            <button className="hold-btn">Hold</button>
                            <button className="hold-btn" onClick={openOutcomeModal}>Call Outcome</button>
                        </div>
                    </div>
                </div>
            )}

            {/* The "Call Outcome" modal */}
            {showOutcomeModal && (
                <div className="outcome-modal-overlay">
                    <div className="outcome-modal-content">
                        <div className="outcome-modal-header">
                            <h4>Post Call Outcome</h4>
                            <button
                                className="modal-close-btn"
                                onClick={closeOutcomeModal}
                            >
                                &times;
                            </button>
                        </div>
                        <div className="outcome-modal-body">
                            <p>Please select the outcome of this call:</p>
                            <div className="post-actions-grid">
                                <div className="cat-box gray">Disconnected</div>
                                <div className="cat-box blue">Reschedule</div>
                                <div className="cat-box yellow">Follow-Up Needed</div>
                                <div className="cat-box green">Deal Closed - Won</div>
                                <div className="cat-box red">Deal Closed - Lost</div>
                                <div className="cat-box orange">Price Objection</div>
                                <div className="cat-box purple">Needs More Info</div>
                                <div className="cat-box teal">Unqualified Lead</div>
                            </div>
                        </div>
                        <div className="outcome-modal-footer">
                            <button className="answer-btn" onClick={closeOutcomeModal}>Close</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AgentCommandCenter;
